
import Vue, {PropType} from "vue";
import {SimpleAttributeValue} from "../../../model/cart/LocalCartItem";

export default Vue.extend({
  name: "ColorAttributeValue",
  props: {
    attrValue: {
      type: Object as PropType<SimpleAttributeValue>,
      default: () => ({
        value: "",
      }),
    },
  },
  computed: {
    hexColor(): string {
      return this.attrValue.value;
    },
  },
});
